import { createAction } from "redux-actions";
import { PAGE_SIZE_10 } from "../../constants/index";
import { apiPost, apiGet, apiDelete, apiPut } from "../../api/index";
import {
  urlStockSecured,
  urlExportStockSecured,
  urlAllStockSecured,
} from "../../api/urls";
import moment from "moment-timezone";

const generateStockFilterQuery = ({ filters, page, pageSize, sort }) => {
  let filter = "?";

  page ? (filter += "page=" + page) : (filter += "page=1");
  pageSize
    ? (filter += "&pageSize=" + pageSize)
    : (filter += "&pageSize=" + PAGE_SIZE_10);

  if (filters) {
    if (filters.status) filter += "&status=" + filters.status;
    if (filters.batch) filter += "&batch=" + filters.batch;
    if (filters.dateInit) {
      const dateInit = moment(filters.dateInit);
      filter += "&dateInit=" + dateInit.valueOf();
    }
    if (filters.dateEnd) {
      const dateEnd = moment(filters.dateEnd);
      filter += "&dateEnd=" + dateEnd.valueOf();
    }
  }

  if (sort) filter += "&sort=" + sort;

  return filter;
};

/**
 * Filter list stock.
 */
export const filterStock = createAction("FILTER_STOCK", (filter, param) =>
  apiGet(urlStockSecured + generateStockFilterQuery(filter), param, true)(),
);

/**
 * Export stock.
 */
export const listStockToExport = createAction(
  "EXPORT_FILTER_STOCK",
  (filter, param) =>
    apiGet(
      urlExportStockSecured + generateStockFilterQuery(filter),
      param,
      true,
    )(),
);

export const listStocks = createAction("FILTER_STOCKS", (filter, param) =>
  apiGet(urlAllStockSecured + generateStockFilterQuery(filter), param, false)(),
);

export const listAll = createAction("LIST_ALL_COMPANY", (param) =>
  apiGet(urlAllStockSecured, param, true)(),
);


